export default "__VITE_ASSET__Dmze8fHL__"